const RefreshState = async () => {
  window.location.href =
    window.location.protocol + "//" + window.location.host;
};
export default RefreshState;
